import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { VolunteerDetails } from '../models/volunteer-details';
import { environment } from '@environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VolunteerApi {
  private readonly http = inject(HttpClient);

  public getCurrentVolunteer(): Observable<VolunteerDetails> {
    const url = `${environment.apiHost}/administration/api/v1/volunteers/me`;

    return this.http.get<VolunteerDetails>(url);
  }
}
